import { call, put } from "redux-saga/effects";

import * as api from "../../api/TdsApi";
import * as types from "../../constants/actionTypes";
import { createErrorMessageAction } from "../../utils/TypescriptUtils";

export function* getMyTopologiesSaga(action) {
  try {
    let returnTopos = [];
    let errors = "";

    for (var i = 0; i < action.environments.length; i++) {
      let topos = [];
      try {
        topos = yield call(api.getJobsByOwner, action.user, action.environments[i]);
      } catch (error) {
        errors += `Unable to retrieve topologies for environment ${action.environments[i].display}. Error ${error}\n`;
      }

      // Add environment to each topology object, add to returnTopos
      for (var j = 0; j < topos.length; j++) {
        topos[j].environment = action.environments[i];
        topos[j].MachinesExt.forEach((machine) => {
          machine.VpnProfileName = topos[j].Regions.VpnProfileName;
        });
        returnTopos.push(topos[j]);
      }
    }

    // Sort so we have Cloud Topologies listed before Classic
    const sortedTopologies = returnTopos.sort((t) => (t.environment.environmentType === "Cloud" ? -1 : 1));

    yield put({ type: types.FETCH_MYTOPOS_SUCCESS, returnTopos: sortedTopologies });

    if (errors.length > 0) {
      throw new Error(errors);
    }
  } catch (error) {
    yield put(createErrorMessageAction(types.FETCH_MYTOPOS_ERROR, error));
  }
}

export function* deleteTopologiesSaga(action) {
  try {
    const response = yield call(api.deleteTopology, action.id, action.environment);
    yield put({ type: types.DELETE_SUCCESS, response });
    if (window.location) {
      window.location.pathname = "/";
    }
  } catch (error) {
    yield put(createErrorMessageAction(types.DELETE_ERROR, error));
  }
}

export function* getTasksSaga(action) {
  try {
    const topologyDetails = yield call(api.getTopologyById, action.topologyId, action.environment);
    const returnValue = {
      machineName: action.machineName,
      topologyDetails: topologyDetails,
      environment: action.environment,
    };
    yield put({ type: types.FETCH_TASKS_SUCCESS, returnValue });
  } catch (error) {
    yield put(createErrorMessageAction(types.FETCH_TASKS_ERROR, error));
  }
}

export function* renameTopologySaga(action) {
  try {
    const response = yield call(api.renameTopology, action.owner, action.id, action.newName, action.environment);
    yield put({ type: types.RENAME_TOPOLOGY_SUCCESS, response });
    if (window.location) {
      window.location.pathname = "/";
    }
  } catch (error) {
    yield put(createErrorMessageAction(types.RENAME_TOPOLOGY_ERROR, error));
  }
}

export function* transferOwnershipSaga(action) {
  try {
    const response = yield call(api.transferOwnership, action.owner, action.id, action.newOwner, action.environment);
    yield put({ type: types.TRANSFER_OWNERSHIP_SUCCESS, response });
    if (window.location) {
      window.location.pathname = "/";
    }
  } catch (error) {
    yield put(createErrorMessageAction(types.TRANSFER_OWNERSHIP_ERROR, error));
  }
}

export function* getDebuggerPortSaga(action) {
  try {
    const port = yield call(api.getVisualStudioRemoteDebuggerPort, action.environment);
    yield put({ type: types.FETCH_DEBUGGER_PORT_SUCCESS, port });
  } catch (error) {
    yield put(createErrorMessageAction(types.FETCH_DEBUGGER_PORT_ERROR, error));
  }
}
